import React, { useState } from 'react';
import Header from 'components/Header';
import TopBar, { useTopBar } from '../topBar/TopBar';
import Footer from '../components/Footer';
import {
  SwipeableDrawer,
  ListItemText,
  ListItem,
  ListItemIcon,
  Hidden
} from '@material-ui/core';

import HomeIcon from 'mdi-react/HomeIcon';
import ExamIcon from 'mdi-react/FileDocumentEditOutlineIcon';
import ResultIcon from 'mdi-react/TrophyOutlineIcon';
import ForumIcon from 'mdi-react/ForumOutlineIcon';

export const TopBarContext = React.createContext();

function DashboardLayout({ history, children }) {
  const topBar = useTopBar();

  const [drawer, setDrawer] = useState(false);

  const toggleDrawer = open => event => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setDrawer(open);
  };

  return (
    <TopBarContext.Provider value={topBar}>
      <React.Fragment>
        <div
          style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
        >
          <Header
            onMenuTapped={() => {
              setDrawer(true);
            }}
          />

          <TopBar {...topBar.props} />
          <Hidden mdUp>
            <SwipeableDrawer
              anchor="left"
              open={drawer}
              onClose={toggleDrawer(false)}
              onOpen={toggleDrawer(true)}
            >
              <div
                style={{
                  width: 220
                }}
                onClick={() => setDrawer(false)}
              >
                <ListItem
                  button
                  onClick={() => {
                    history.push('/');
                  }}
                >
                  <ListItemIcon>
                    <HomeIcon />
                  </ListItemIcon>
                  <ListItemText primary="Home" />
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    history.push('/exam');
                  }}
                >
                  <ListItemIcon>
                    <ExamIcon />
                  </ListItemIcon>
                  <ListItemText primary="Exams" />
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    history.push('/result');
                  }}
                >
                  <ListItemIcon>
                    <ResultIcon />
                  </ListItemIcon>
                  <ListItemText primary="Result" />
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    history.push('/forum');
                  }}
                >
                  <ListItemIcon>
                    <ForumIcon />
                  </ListItemIcon>
                  <ListItemText primary="Forum" />
                </ListItem>
              </div>
            </SwipeableDrawer>
          </Hidden>
          <div
            style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}
          >
            {children}
          </div>
          <Footer />
        </div>
      </React.Fragment>
    </TopBarContext.Provider>
  );
}

export default DashboardLayout;
